import React, { useContext, useState } from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { MarkEmailUnreadOutlined, SmartToyOutlined, UploadOutlined } from '@mui/icons-material';
import { SendOutlined } from '@mui/icons-material';
import UserContext from '../context/UsersContext';
import { InvitationType } from '../constant/InvitationType.enum';

type OptionDetails = {
    label: string,
    description: InvitationType,
    icon: React.ReactElement
}

const options: OptionDetails[] = [
    {
        label: 'Send Email',
        description: InvitationType.InviteUsersViaEmail,
        icon: <MarkEmailUnreadOutlined />,
    },
    {
        label: 'CSV Upload',
        description: InvitationType.InviteUsersViaCSV,
        icon: <UploadOutlined />,
    },
    {
        label: 'Virtual Agent',
        description: InvitationType.AddVirtualAgent,
        icon: <SmartToyOutlined />,
    },
]

const InviteButton: React.FC = () => {
    const { setSelectedInvitationType } = useContext(UserContext);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const renderMenuItem = ({ label, description, icon }: OptionDetails) => {
        return (
            <MenuItem
                key={label}
                onClick={() => {
                    setAnchorEl(null);
                    setSelectedInvitationType(description);
                }}>
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={label} secondary={description} />
            </MenuItem>
        );
    }

    return (
        <>
            <Button
                variant="contained"
                color="success"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                endIcon={<SendOutlined />}
            >
                Invite
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                {options.map((option, index) => renderMenuItem(option))}
            </Menu>
        </>
    );
};

export default InviteButton;
